import classNames from 'classnames'

import { Author } from '../interfaces'

/* eslint-disable import/no-internal-modules */
import UserAvatar from '@insided/deprecated-preact-components/User/UserAvatar'

export interface PostAuthorProps {
  author: Author
}

const PostAuthor = ({ author }: PostAuthorProps) => {
  return (
    <div className='user-avatar--container clearfix'>
      <UserAvatar
        user={{ ...author, name: author.username, url: `/member/profile/?userid=${author.id}` }}
        extraClass='avatar avatar--L'
        style={{ float: 'left' }}
        showRank
        openInNewTab
      />
      <div className='user-avatar--info'>
        <h4>
          <strong>
            <a href={`/member/profile/?userid=${author.id}`}>{author.username}</a>
          </strong>
        </h4>
        <span>{author.customTitle ?? author.reputation.rank}</span>
        <span className={classNames('text-muted', 'posts-count', 'clearfix')}>
          {author.reputation.repliesMade} replies
        </span>
      </div>
    </div>
  )
}

export default PostAuthor
